module.exports = __webpack_public_path__ + "img/replacements.b3ac873e.svg";